import { View } from "tamagui";
import { Check as CheckIcon, DollarSign as DollarSignIcon, HelpCircle as HelpCircleIcon, Plus as PlusIcon } from "@tamagui/lucide-icons";
import { shadow } from "../../themes/token-shadow";
export type BrandGraphicIndicatorKind = "plus" | "question" | "check" | "dollar";
const ICONS = {
  plus: PlusIcon,
  question: HelpCircleIcon,
  check: CheckIcon,
  dollar: DollarSignIcon
} as const;

// Ratio of the glyph size to the circle diameter (a 24px glyph in a 48px circle).
const GLYPH_RATIO = 0.5;
type BrandGraphicIndicatorProps = {
  kind: BrandGraphicIndicatorKind;
  diameter: number;
  left: number;
  top: number;
};

// The green circle overlay with a single glyph, placed over a brand graphic.
export const BrandGraphicIndicator = ({
  kind,
  diameter,
  left,
  top
}: BrandGraphicIndicatorProps) => {
  const Glyph = ICONS[kind];
  return <View testID={`brand-graphic-indicator-${kind}`} position="absolute" left={left} top={top} width={diameter} height={diameter} borderRadius="$brFull" backgroundColor="$bgBrandStrong" alignItems="center" justifyContent="center" {...shadow.heavy} data-sentry-element="View" data-sentry-component="BrandGraphicIndicator" data-sentry-source-file="BrandGraphicIndicator.tsx">
      <Glyph size={diameter * GLYPH_RATIO} color="$iconDefault" strokeWidth={3} data-sentry-element="Glyph" data-sentry-source-file="BrandGraphicIndicator.tsx" />
    </View>;
};